import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
}                         from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RbAuthService }  from '../core';

@Component({
  selector: 'rb-logout',
  standalone: false,
  templateUrl: './logout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  officeId: string | null = null;

  constructor(
    private readonly rbAuthService: RbAuthService,
    private readonly route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.officeId = this.route.snapshot.queryParamMap.get('officeId');
  }

  login(): void {
    this.rbAuthService.login('/', false);
  }
}
